/* eslint-disable */

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import L from 'leaflet';
import 'leaflet.markercluster';

function mspcUrl(code) {
    return String(code).length > 5
        ? `http://mspcsearch.militaryarchives.ie/dispatcher.aspx?action=search&database=medals&search=priref=${code}`
        : `http://mspcsearch.militaryarchives.ie/dispatcher.aspx?action=detail&database=pensions&priref=${code}`;
}

// Reference codes for records that should not link to a single view
const NO_SINGLE_VIEW = new Set(['120000546']);

// --- Placeholder pin colours — change these to match the site palette ---
const PIN_DEFAULT   = '#3f3e31'; // standard location pin
const PIN_EXECUTION = '#364644'; // execution site pin
const PIN_FATALITY  = '#485048'; // fatality site
const PIN_SUMMARY   = '#729b85'; // summary location marker (shared by all summary sites)

// -------------------------------------------------------------------------

// Summary locations — dynamically computed from the API data.
// Any lat/lng coordinate shared by more than SUMMARY_THRESHOLD records becomes
// a summary location with its own popup and table-filtering behaviour.
// Populated in the fetch callback before addMarkers() is called.
const SUMMARY_THRESHOLD = 9;
let SUMMARY_LOCATIONS = [];
let FEATURED_LOCATIONS = [
    {
        storyname: "South Dublin Union",
        location: "South Dublin Union, James's Street, Dublin",
        latitude: "53.3431735",
        longitude: "-6.2902600",
        slug: "south-dublin-union",
        image: '/uploads/images/1916-guides-South-Dublin-Union-entrance-BMH-1952.jpg',
    },
    {
        storyname: "Jacob's Factory",
        location: "Jacob's Biscuit Factory, Bishop Street, Dublin",
        latitude: "53.3383462",
        longitude: "-6.2677148",
        slug: "jacobs-factory",
        image: '/uploads/images/1916Places-Jacobs1.jpg',
    },
    {
        storyname: "Area of Boland’s Mills/Bakery",
        location: "Boland's Bakery/Boland's Mills, Grand Canal Street, Dublin",
        latitude: "53.3420795",
        longitude: "-6.2371632",
        slug: "bolands-mills",
        image: '/uploads/images/IE-MA-BMH-P-32-004.jpg',
    },
    {
        storyname: "Little's Public House, Harcourt Street, Dublin",
        location: "Little's Public House, Harcourt Street, Dublin",
        latitude: "53.3376300",
        longitude: "-6.2629000",
        slug: "littles-public-house-harcourt-street-dublin",
        image: '/uploads/images/IE-MA-BMH-P-36-063.jpg',
    },
    {
        storyname: "Kinvara, County Galway",
        location: "Kinvara, County Galway",
        latitude: "53.1389085",
        longitude: "-8.9362964",
        slug: "kinvara-county-galway",
        image: '/uploads/images/A21-_4_A-Galway-Easter-Week-1916.jpg-66.jpg',
    },
    {
        storyname: "County Galway",
        location: "County Galway",
        latitude: "53.3564509",
        longitude: "-8.8534113",
        slug: "county-galway",
        image: '/uploads/images/A21-_4_A-Galway-Easter-Week-1916.jpg-65.jpg',
    },
    {
        storyname: "Father Matthew Hall",
        location: "Father Matthew Hall, Church Street, Dublin",
        latitude: "53.3494298",
        longitude: "-6.2749072",
        slug: "father-matthew-hall",
        image: '/uploads/images/FatherMatHall.jpg',
    },
    {
        storyname: "Liberty Hall",
        location: "Liberty Hall, Beresford Place, Dublin",
        latitude: "53.3484728",
        longitude: "-6.2556986",
        slug: "liberty-hall",
        image: '/uploads/images/liberty-hall.jpg',
    },
    {
        storyname: "The Battle of Ashbourne",
        location: "Ashbourne, County Meath",
        latitude: "53.5106742",
        longitude: "-6.3969054",
        slug: "ashbourne-1916",
        image: '/uploads/images/Thomas_Ashe_-_portrait_photograph_2026-04-02-145219_jarc.jpg',
    },
    {
        storyname: "Area of Church Street, Dublin",
        location: "Church Street, Dublin",
        latitude: "53.346486",
        longitude: "-6.275262",
        slug: "father-matthew-hall",
        image: '/uploads/images/FatherMatHall.jpg',
    },
    {
        storyname: "Metropole Hotel, O'Connell Street, Dublin",
        location: "Metropole Hotel, O'Connell Street, Dublin",
        latitude: "53.3488674",
        longitude: "-6.26031972",
        slug: "metropole-hotel-oconnell-street-dublin",
        image: '/uploads/images/IE-MA-BMH-P-31-015.jpg',
    },
    {
        storyname: "Mount Street",
        location: "Mount Street, Dublin",
        latitude: "53.3385739",
        longitude: "-6.2433888",
        slug: "mount-street",
        image: '/uploads/images/IE-MA-BMH-P-31-015.jpg',
    },
    {
        storyname: "Davy's Public House",
        location: "Davy's Public House, 42 Lower Camden Street, Dublin",
        latitude: "53.3305",
        longitude: "-6.26391",
        slug: "davys-public-house",
        image: '/uploads/images/Davys-Pub.jpg',
    }
    
];

// Build the summary locations array from the full dataset.
// Groups all lat/lng pairs (primary + location_2…location_10) by coordinate,
// then promotes any coordinate with more than `threshold` distinct records.
function computeDynamicSummaryLocations(data, threshold) {
    // Map from coordinate key → { lat, lng, locIds: Set, locationTexts: [] }
    const buckets = new Map();

    data.forEach(loc => {
        const pairs = [{ lat: loc.latitude, lng: loc.longitude, text: loc.location }];
        for (let i = 2; i <= 10; i++) {
            pairs.push({ lat: loc[`latitude_${i}`], lng: loc[`longitude_${i}`], text: loc[`location_${i}`] });
        }

        pairs.forEach(({ lat, lng, text }) => {
            const latF = parseFloat(lat);
            const lngF = parseFloat(lng);
            if (isNaN(latF) || isNaN(lngF) || (latF === 0 && lngF === 0)) return;

            // Round to 5 dp (matches SUMMARY_TOLERANCE) to produce a stable bucket key
            const key = `${Math.round(latF * 1e5)},${Math.round(lngF * 1e5)}`;
            if (!buckets.has(key)) {
                buckets.set(key, { lat: latF, lng: lngF, locIds: new Set(), locationTexts: [] });
            }
            const bucket = buckets.get(key);
            bucket.locIds.add(loc.id);
            if (text) bucket.locationTexts.push(text);
        });
    });

    const result = [];
    buckets.forEach(({ lat, lng, locIds, locationTexts }, key) => {
        if (locIds.size <= threshold) return;

        // Use the most frequent location text as the summary label
        const freq = {};
        locationTexts.forEach(t => { freq[t] = (freq[t] || 0) + 1; });
        const label = locationTexts.length > 0
            ? Object.entries(freq).sort((a, b) => b[1] - a[1])[0][0]
            : `${lat.toFixed(4)}, ${lng.toFixed(4)}`;

        result.push({
            id:         `dyn_${key.replace(/[^a-z0-9]/gi, '_')}`,
            lat,
            lng,
            label,
            color:      PIN_SUMMARY,
            story:      false,
            totalCount: locIds.size,
        });
    });

    return result;
}

const SUMMARY_TOLERANCE = 0.00001;

function findSummaryLocation(lat, lng) {
    return SUMMARY_LOCATIONS.find(
        s => Math.abs(lat - s.lat) < SUMMARY_TOLERANCE && Math.abs(lng - s.lng) < SUMMARY_TOLERANCE
    ) || null;
}

function findFeaturedLocation(lat, lng) {
    return FEATURED_LOCATIONS.find(
        f => Math.abs(lat - parseFloat(f.latitude)) < SUMMARY_TOLERANCE &&
             Math.abs(lng - parseFloat(f.longitude)) < SUMMARY_TOLERANCE
    ) || null;
}

// Returns a teardrop SVG divIcon in the given colour
function createPinIcon(color) {
    return L.divIcon({
        className: '',
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36">
            <path d="M12 0C5.4 0 0 5.4 0 12c0 7.2 12 24 12 24S24 19.2 24 12C24 5.4 18.6 0 12 0z"
                  fill="${color}" stroke="white" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="4" fill="white"/>
        </svg>`,
        iconSize:     [24, 36],
        iconAnchor:   [12, 36],
        popupAnchor:  [0, -38],
    });
}

// API URL is set by the Twig template via a {% js %} block
const apiUrl = window.locations1916ApiUrl;

const PAGE_SIZE = 20;

// All loaded locations — kept in memory for client-side filtering
let allLocations = [];
// The full result of the active filter (never narrowed by summary selection)
let baseFilteredLocations = [];
// The current filtered set shown in the table
let currentFilteredLocations = [];
// How many table rows are currently visible
let tableVisibleCount = 0;
// Map<loc.id, locationText> for the active location filter (null when not filtering by location)
let currentMatchedLocationsMap = null;
// Map marker objects keyed by markerId (loc.id + optional suffix)
let markers = {};
// Summary markers keyed by summary location id (rebuilt on each filter change)
let summaryMarkers = {};
// Maps loc.id → summary location id (for table row click behaviour)
let locSummaryMap = new Map();
// Records belonging to the currently-selected summary pin (null when no summary is active)
let activeSummaryLocations = null;

// On touch devices, require two fingers to pan the map so single-finger scroll works.
// Leaflet sets touch-action:none (inline) on its container and child elements.
// We override this with a CSS !important rule tied to .map-scroll-enabled so the
// browser handles single-finger scroll at compositor level — no JS can block it.
function enableMobileTwoFingerDrag(leafletMap) {
    const container = leafletMap.getContainer();
    // Always set touch-action:pan-y via the CSS class so the browser compositor
    // allows native single-finger page scroll. touch-action has no effect on
    // mouse events, so desktop mouse dragging is completely unaffected here.
    container.classList.add('map-scroll-enabled');
    // Do NOT disable dragging at init. Only disable it reactively inside the
    // touchstart handler below. On a desktop (no touchscreen) touchstart never
    // fires, so dragging is never disabled and mouse drag always works.
    const hint = document.createElement('div');
    hint.className = 'map-gesture-hint';
    hint.textContent = 'Use two fingers to move the map';
    container.appendChild(hint);
    let hintTimer;
    container.addEventListener('touchstart', function(e) {
        if (e.touches.length >= 2) {
            container.classList.remove('map-scroll-enabled');
            leafletMap.dragging.enable();
            hint.classList.remove('visible');
            clearTimeout(hintTimer);
        } else {
            container.classList.add('map-scroll-enabled');
            leafletMap.dragging.disable();
            hint.classList.add('visible');
            clearTimeout(hintTimer);
            hintTimer = setTimeout(function() { hint.classList.remove('visible'); }, 1500);
        }
    }, { passive: true });
    container.addEventListener('touchend', function(e) {
        if (e.touches.length < 2) {
            leafletMap.dragging.disable();
            container.classList.add('map-scroll-enabled');
        }
    }, { passive: true });
}

// Initialise the Leaflet map centred on Ireland
// scrollWheelZoom is disabled by default — it activates only while Ctrl is held
const map = L.map('map-1916', { zoomControl: false, scrollWheelZoom: false }).setView([53.1424, -7.6921], 7);
enableMobileTwoFingerDrag(map);
L.control.zoom({ position: 'topright' }).addTo(map);

// Ctrl + scroll to zoom (mirrors Google Maps behaviour)
document.addEventListener('keydown', (e) => { if (e.key === 'Control') map.scrollWheelZoom.enable(); });
document.addEventListener('keyup',   (e) => { if (e.key === 'Control') map.scrollWheelZoom.disable(); });

// Show a brief hint when the user scrolls on the map without Ctrl
(function () {
    let hintTimer;
    map.getContainer().addEventListener('wheel', (e) => {
        if (e.ctrlKey) return;
        const container = map.getContainer();
        let hint = container.querySelector('.map-scroll-hint');
        if (!hint) {
            hint = document.createElement('div');
            hint.className = 'map-scroll-hint';
            hint.textContent = 'Use Ctrl + scroll to zoom the map';
            container.appendChild(hint);
        }
        hint.classList.add('visible');
        clearTimeout(hintTimer);
        hintTimer = setTimeout(() => hint.classList.remove('visible'), 1500);
    }, { passive: true });
}());

// Mapbox tile layer — swap the style ID for any style from your Mapbox Studio account
// Restrict this token to your domain: Mapbox dashboard → Tokens → edit → Allowed URLs
const MAPBOX_TOKEN = 'pk.eyJ1Ijoic2VhbmNvbjczIiwiYSI6ImNtbWF1eGV2OTBnbWgycnNkOGxmaDEwbzcifQ.BdNcGJ_7H_aj9YTmmYIWfg';
//const MAPBOX_STYLE = 'mapbox/streets-v12'; // change to your custom style ID if needed
const MAPBOX_STYLE = 'seancon73/cmmdnwa32009s01sk6jku8zqz';

L.tileLayer(`https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/256/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`, {
    attribution: '&copy; <a href="https://www.mapbox.com/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    tileSize: 256,
    maxZoom: 19,
}).addTo(map);

// Cluster group — added to the map once, refilled on each filter change.
// spiderfyOnMaxZoom handles the case where multiple markers share an exact
// lat/lng: clicking the cluster at max zoom spreads them into a spider.
const clusterGroup = L.markerClusterGroup({
    spiderfyOnMaxZoom: true,
    polygonOptions: {
        color:       '#626d46',
        fillColor:   '#8aad7f',
        weight:      2,
        opacity:     0.8,
        fillOpacity: 0.2,
    },
    // Show total record count (not pin count) — summary pins represent many records each
    iconCreateFunction: function(cluster) {
        const total = cluster.getAllChildMarkers()
            .reduce((sum, m) => sum + (m.options.recordCount || 1), 0);
        const label = total >= 1000 ? `${Math.floor(total / 1000)}k+` : String(total);
        const size = total < 10 ? 'small' : total < 100 ? 'medium' : 'large';
        const px = size === 'small' ? 28 : size === 'medium' ? 36 : 44;
        return L.divIcon({
            html: `<div><span>${label}</span></div>`,
            className: `marker-cluster marker-cluster-${size}`,
            iconSize: L.point(px, px),
        });
    },
});
map.addLayer(clusterGroup);

// Show/hide the fixed info panel in the top-left of the map container
function showInfoPanel(html, featured = false) {
    const panel = document.getElementById('map-1916-info-panel');
    const content = document.getElementById('map-1916-info-content');
    if (!panel || !content) return;
    content.innerHTML = html;
    panel.classList.toggle('is-featured', featured);
    panel.style.display = 'block';
    const stickyNav = document.querySelector('.online-sub-nav.sticky-lg-top');
    const navHeight = stickyNav ? stickyNav.getBoundingClientRect().height : 0;
    const mobileOffset = window.innerWidth < 768 ? 115 : 0;
    const top = panel.getBoundingClientRect().top + window.scrollY - navHeight - mobileOffset - 8;
    window.scrollTo({ top, behavior: 'smooth' });
}

function hideInfoPanel() {
    const panel = document.getElementById('map-1916-info-panel');
    if (panel) panel.style.display = 'none';
}

const STAR_ICON = `<span class="featured-star" title="Featured story" aria-label="Featured">&#9733; Story</span>`;
const STAR_ICON_TABLE = `<span class="featured-star" title="Featured story" aria-label="Featured">&#9733;</span>`;

// Build info panel HTML for a location
// featuredLocation: optional entry from FEATURED_LOCATIONS if this marker sits on a featured site
function buildPopup(loc, locationText, featuredLocation) {
    const isFeatured = loc.featured == 1 || !!featuredLocation;
    let storyUrl
    if (featuredLocation?.slug) {
        storyUrl = `${window.featuredStory1916BaseUrl}/${featuredLocation.slug}`;
    }
    const nameUrl = storyUrl || loc.view_url;
    const noLink = NO_SINGLE_VIEW.has(String(loc.reference_code));
    let html = isFeatured
        ? (noLink ? `${STAR_ICON}<h3>${loc.name}</h3>` : `${STAR_ICON}<h3><a href="${nameUrl}">${loc.name}</a></h3>`)
        : (noLink ? `<h3>${loc.name}</h3>` : `<h3><a href="${loc.view_url}">${loc.name}</a></h3>`);
   
    
    if (loc.county) {
        html += `<p><strong>County:</strong> ${loc.county}</p>`;
    }
    if (locationText) {
        html += `<p><strong>Location:</strong> ${locationText}</p>`;
    }
    if (loc.organisation) {
        html += `<p class="mt-0"><strong>Organisation:</strong> ${loc.organisation}</p>`;
    }
    if (loc.description) {
        html += `<p>${loc.description}</p>`;
    }
     if (loc.reference_code) {
         html += `<p><a href="${mspcUrl(loc.reference_code)}">View MSPC Record <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0361 0.25C16.1369 0.247123 16.2375 0.266889 16.3301 0.306641C16.4225 0.346372 16.5051 0.405636 16.5723 0.480469C16.6396 0.555553 16.6902 0.644762 16.7197 0.741211C16.7492 0.837602 16.757 0.939221 16.7432 1.03906L16.7412 1.05566V5.67676C16.7425 5.76866 16.7257 5.86003 16.6914 5.94531C16.6571 6.03064 16.6056 6.10834 16.541 6.17383C16.4766 6.23906 16.4 6.29073 16.3154 6.32617C16.2306 6.36167 16.1388 6.38086 16.0469 6.38086C15.955 6.38082 15.8641 6.36163 15.7793 6.32617C15.6945 6.29068 15.6173 6.23927 15.5527 6.17383C15.4882 6.10839 15.4376 6.03057 15.4033 5.94531C15.369 5.86003 15.3522 5.76866 15.3535 5.67676V2.62891L14.9268 3.05566L6.1543 11.8271L6.15039 11.8311C6.08656 11.8974 6.01031 11.9507 5.92578 11.9873C5.84104 12.0239 5.74954 12.043 5.65723 12.0439C5.5649 12.0449 5.47318 12.0271 5.3877 11.9922C5.3023 11.9573 5.22441 11.906 5.15918 11.8408C5.09394 11.7756 5.04269 11.6977 5.00781 11.6123C4.97292 11.5268 4.95512 11.4351 4.95605 11.3428C4.95703 11.2507 4.97623 11.1597 5.0127 11.0752C5.04933 10.9904 5.10332 10.9136 5.16992 10.8496L5.17285 10.8457L13.9453 2.07422L14.3721 1.64746H11.3242C11.2324 1.64876 11.1409 1.63184 11.0557 1.59766C10.9703 1.56337 10.8926 1.51183 10.8271 1.44727C10.7617 1.38278 10.7093 1.30639 10.6738 1.22168C10.6383 1.13684 10.6201 1.04509 10.6201 0.953125C10.6202 0.861298 10.6384 0.770263 10.6738 0.685547C10.7093 0.60076 10.7617 0.523519 10.8271 0.458984C10.8926 0.394589 10.9705 0.343796 11.0557 0.30957C11.1409 0.275373 11.2324 0.258467 11.3242 0.259766H15.9414L15.959 0.256836L16.0361 0.25ZM15.3535 9.44531C15.3522 9.35339 15.369 9.26207 15.4033 9.17676C15.4376 9.09149 15.4882 9.0137 15.5527 8.94824C15.6173 8.88276 15.6945 8.83042 15.7793 8.79492C15.864 8.75949 15.955 8.74125 16.0469 8.74121C16.1388 8.74121 16.2306 8.75943 16.3154 8.79492C16.4001 8.83039 16.4765 8.88288 16.541 8.94824C16.6056 9.01373 16.6571 9.09143 16.6914 9.17676C16.7256 9.26202 16.7425 9.35344 16.7412 9.44531V15.1123C16.7411 16.0058 15.9971 16.7498 15.1035 16.75H1.8877C0.994093 16.7499 0.25007 16.0059 0.25 15.1123V1.89746C0.25 1.00386 0.994051 0.259879 1.8877 0.259766H7.55469C7.64665 0.258465 7.73888 0.275279 7.82422 0.30957C7.90921 0.343787 7.98646 0.394716 8.05176 0.458984C8.11721 0.523511 8.16959 0.600772 8.20508 0.685547C8.24052 0.770263 8.25874 0.861298 8.25879 0.953125C8.25879 1.04509 8.24057 1.13684 8.20508 1.22168C8.16959 1.30639 8.11717 1.38278 8.05176 1.44727C7.98636 1.51174 7.90941 1.56337 7.82422 1.59766C7.73888 1.63195 7.64665 1.64876 7.55469 1.64746H1.6377V15.3623H15.3535V9.44531Z" fill="black" stroke="#E4ECE9" stroke-width="0.5"/>
</svg></a></p>`;
     }
    if (featuredLocation?.slug) {
        html += `<p><a href="${storyUrl}" class="leaflet-popup-link">Read featured story</a></p>`;
    }

    return html;
}

// Build and append a single table row.
// matchedLocation: if provided (location filter active), show this instead of loc.location
function buildTableRow(loc, matchedLocation) {
    const tr = document.createElement('tr');
    tr.dataset.id = loc.id;
    const refCell = loc.reference_code
        ? `<a href="${mspcUrl(loc.reference_code)}">View MSPC record
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0361 0.25C16.1369 0.247123 16.2375 0.266889 16.3301 0.306641C16.4225 0.346372 16.5051 0.405636 16.5723 0.480469C16.6396 0.555553 16.6902 0.644762 16.7197 0.741211C16.7492 0.837602 16.757 0.939221 16.7432 1.03906L16.7412 1.05566V5.67676C16.7425 5.76866 16.7257 5.86003 16.6914 5.94531C16.6571 6.03064 16.6056 6.10834 16.541 6.17383C16.4766 6.23906 16.4 6.29073 16.3154 6.32617C16.2306 6.36167 16.1388 6.38086 16.0469 6.38086C15.955 6.38082 15.8641 6.36163 15.7793 6.32617C15.6945 6.29068 15.6173 6.23927 15.5527 6.17383C15.4882 6.10839 15.4376 6.03057 15.4033 5.94531C15.369 5.86003 15.3522 5.76866 15.3535 5.67676V2.62891L14.9268 3.05566L6.1543 11.8271L6.15039 11.8311C6.08656 11.8974 6.01031 11.9507 5.92578 11.9873C5.84104 12.0239 5.74954 12.043 5.65723 12.0439C5.5649 12.0449 5.47318 12.0271 5.3877 11.9922C5.3023 11.9573 5.22441 11.906 5.15918 11.8408C5.09394 11.7756 5.04269 11.6977 5.00781 11.6123C4.97292 11.5268 4.95512 11.4351 4.95605 11.3428C4.95703 11.2507 4.97623 11.1597 5.0127 11.0752C5.04933 10.9904 5.10332 10.9136 5.16992 10.8496L5.17285 10.8457L13.9453 2.07422L14.3721 1.64746H11.3242C11.2324 1.64876 11.1409 1.63184 11.0557 1.59766C10.9703 1.56337 10.8926 1.51183 10.8271 1.44727C10.7617 1.38278 10.7093 1.30639 10.6738 1.22168C10.6383 1.13684 10.6201 1.04509 10.6201 0.953125C10.6202 0.861298 10.6384 0.770263 10.6738 0.685547C10.7093 0.60076 10.7617 0.523519 10.8271 0.458984C10.8926 0.394589 10.9705 0.343796 11.0557 0.30957C11.1409 0.275373 11.2324 0.258467 11.3242 0.259766H15.9414L15.959 0.256836L16.0361 0.25ZM15.3535 9.44531C15.3522 9.35339 15.369 9.26207 15.4033 9.17676C15.4376 9.09149 15.4882 9.0137 15.5527 8.94824C15.6173 8.88276 15.6945 8.83042 15.7793 8.79492C15.864 8.75949 15.955 8.74125 16.0469 8.74121C16.1388 8.74121 16.2306 8.75943 16.3154 8.79492C16.4001 8.83039 16.4765 8.88288 16.541 8.94824C16.6056 9.01373 16.6571 9.09143 16.6914 9.17676C16.7256 9.26202 16.7425 9.35344 16.7412 9.44531V15.1123C16.7411 16.0058 15.9971 16.7498 15.1035 16.75H1.8877C0.994093 16.7499 0.25007 16.0059 0.25 15.1123V1.89746C0.25 1.00386 0.994051 0.259879 1.8877 0.259766H7.55469C7.64665 0.258465 7.73888 0.275279 7.82422 0.30957C7.90921 0.343787 7.98646 0.394716 8.05176 0.458984C8.11721 0.523511 8.16959 0.600772 8.20508 0.685547C8.24052 0.770263 8.25874 0.861298 8.25879 0.953125C8.25879 1.04509 8.24057 1.13684 8.20508 1.22168C8.16959 1.30639 8.11717 1.38278 8.05176 1.44727C7.98636 1.51174 7.90941 1.56337 7.82422 1.59766C7.73888 1.63195 7.64665 1.64876 7.55469 1.64746H1.6377V15.3623H15.3535V9.44531Z" fill="black" stroke="#E4ECE9" stroke-width="0.5"/>
</svg>
</a>`
        : loc.reference_code || '';

    let displayLocation, extraText;
    if (matchedLocation) {
        // Show the matched location; indicate if there are other locations too
        let totalCount = 1; // loc.location counts as 1
        for (let i = 2; i <= 13; i++) { if (loc[`location_${i}`]) totalCount++; }
        displayLocation = matchedLocation;
        extraText = totalCount > 1 ? ` <em class="text-muted" style="font-size:0.85em">(${totalCount} locations)</em>` : '';
    } else {
        let extraCount = 0;
        for (let i = 2; i <= 13; i++) { if (loc[`location_${i}`]) extraCount++; }
        displayLocation = loc.location || '';
        extraText = extraCount > 0 ? ` <em class="text-muted" style="font-size:0.85em">and ${extraCount} more location${extraCount !== 1 ? 's' : ''}</em>` : '';
    }

    tr.innerHTML = `
        <td>${NO_SINGLE_VIEW.has(String(loc.reference_code)) ? (loc.name || '') : `<a href="${loc.view_url}">${loc.name || ''}</a>`}</td>
        <td>${displayLocation}${extraText}</td>
        <td>${loc.organisation || ''}</td>
        <td>${loc.gender || ''}</td>
        <td>${refCell}</td>
        <td>${loc.featured == 1 ? STAR_ICON_TABLE : ''}</td>
    `;
    return tr;
}

// Update the Load More button visibility
function updateLoadMoreButton() {
    const btn = document.getElementById('load-more-1916');
    if (!btn) return;
    if (tableVisibleCount < currentFilteredLocations.length) {
        btn.textContent = 'Load more';
        btn.style.display = '';
    } else if (tableVisibleCount > PAGE_SIZE) {
        btn.textContent = 'Show less';
        btn.style.display = '';
    } else {
        btn.style.display = 'none';
    }
}

// Populate the data table body — shows first PAGE_SIZE rows, resets on each call.
// matchedLocationsMap: optional Map<loc.id, locationText> for location-filtered results
function populateTable(locations, matchedLocationsMap) {
    const tbody = document.getElementById('locations-1916-tbody');
    if (!tbody) return;

    currentFilteredLocations = locations;
    currentMatchedLocationsMap = matchedLocationsMap || null;
    tableVisibleCount = 0;
    tbody.innerHTML = '';

    const slice = locations.slice(0, PAGE_SIZE);
    slice.forEach(loc => tbody.appendChild(buildTableRow(loc, matchedLocationsMap?.get(loc.id))));
    tableVisibleCount = slice.length;

    updateLoadMoreButton();
}

// Build a summary marker for a named site with many records sharing one coordinate.
// Clicking opens the info panel and filters the table to those records.
function createSummaryMarker(summary, locations) {
    const count = locations.length;
    const countLabel = count >= 1000 ? `${Math.floor(count / 1000)}k+` : String(count);
    const showCount = count > SUMMARY_THRESHOLD;
    const icon = L.divIcon({
        className: '',
        html: `
<svg width="28" height="40" viewBox="0 0 28 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_226_13)">
<g filter="url(#filter0_d_226_13)">
<path d="M25.5385 12.7692C25.5385 20.6154 13.7692 37.5 13.7692 37.5C13.7692 37.5 2 20.6154 2 12.7692C2 6.35892 7.35892 1 13.7692 1C20.1795 1 25.5385 6.35892 25.5385 12.7692Z" fill="#9BBCAE" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
${showCount ? `<path d="M13.7693 22C18.7399 22 22.7693 17.9706 22.7693 13C22.7693 8.02942 18.7399 4 13.7693 4C8.79871 4 4.76929 8.02942 4.76929 13C4.76929 17.9706 8.79871 22 13.7693 22Z" fill="white" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>` : ''}
${showCount ? `<text x="13.77" y="13" text-anchor="middle" dominant-baseline="middle" font-size="7" font-weight="bold" font-family="Arial,sans-serif" fill="black">${countLabel}</text>` : ''}
</g>
</g>
<defs>
<filter id="filter0_d_226_13" x="-0.5" y="0.5" width="28.5385" height="41.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="1"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_226_13"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_226_13" result="shape"/>
</filter>
<clipPath id="clip0_226_13">
<rect width="28" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`,
        iconSize: [24, 36],
        iconAnchor: [12, 36],
        popupAnchor: [0, -40],
    });

    let storyUrl = "";

    if (summary.story && summary.storyslug) {
        storyUrl = `${window.featuredStory1916BaseUrl}/${summary.storyslug}`;  
    }

    const title = (summary.story && summary.storyname) ? summary.storyname : summary.label;
    let content = summary.story ? `${STAR_ICON}<h3><a href="${storyUrl}">${title}</a></h3>` : `<h3>${title}</h3>`;
    if (summary.image) {
        content += `<img class="map-popup-image mb-2" src="${summary.image}" />`;
    }
   if (summary.storyname) {
       content += `
    <div class="summary-row">
        <span class="summary-label">Location:</span>
        <span class="summary-value">${summary.label}</span>
    </div>`;
   }

   const featuredAtLocation = locations.filter((loc) => loc.featured == 1);

   if (featuredAtLocation.length > 0) {
       content += `
    <div class="summary-row">
        <div class="summary-label">Individual Stories:</div>
        <div class="summary-value summary-links">`;

       featuredAtLocation.forEach((loc) => {
           content += NO_SINGLE_VIEW.has(String(loc.reference_code)) ? loc.name : `<a href="${loc.view_url}">${loc.name}</a>`;
       });

       content += `</div></div>`;
   }

   const displayCount =
       summary.story && summary.totalCount
           ? summary.totalCount
           : locations.length;

   content += `
<div class="summary-row">
    <span class="summary-label">Individual${
        displayCount !== 1 ? 's' : ''
    }:</span>
    <span class="summary-value">${displayCount}</span>
</div>`;

   content += `
<div class="summary-row">
    <a href="#locations-1916-table" class="summary-table-link">
        View updated table below
    </a>
</div>`;

    const marker = L.marker([summary.lat, summary.lng], { icon, recordCount: count });
    marker.on('click', () => {
        activeSummaryLocations = locations;
        showInfoPanel(content, !!summary.story);
        populateTable(locations);
    });
    return marker;
}

// Add markers to the map for the given locations.
// Each row can have up to 10 lat/lng pairs (latitude/longitude through latitude_10/longitude_10).
// Records whose coordinate matches a summary location are omitted from the cluster
// group and instead represented by a single summary marker for that site.
function addMarkers(locations, locationFilter = '') {
    clusterGroup.clearLayers();
    markers = {};

    // Summary markers were added to clusterGroup — cleared above by clusterGroup.clearLayers()
    summaryMarkers = {};
    locSummaryMap = new Map();

    // Bucket to collect records for each summary location
    const summaryBuckets = {};
    SUMMARY_LOCATIONS.forEach(s => { summaryBuckets[s.id] = []; });

    const newMarkers = [];
    // Track which FEATURED_LOCATIONS already have a marker so we can fill gaps below
    const coveredFeaturedSlugs = new Set();

    locations.forEach(loc => {
        // Skip people whose primary location is "unknown" — they have no mappable position
        if ((loc.location || '').trim().toLowerCase() === 'unknown') return;

        const pinColor = loc.execution == 1 ? PIN_EXECUTION
                       : loc.fatality  == 1 ? PIN_FATALITY
                       : PIN_DEFAULT;
        const icon = createPinIcon(pinColor);

        // Build list of all lat/lng pairs for this row (primary + 2-10)
        const pairs = [{ lat: loc.latitude, lng: loc.longitude, suffix: '', locationText: loc.location }];
        for (let i = 2; i <= 10; i++) {
            pairs.push({ lat: loc[`latitude_${i}`], lng: loc[`longitude_${i}`], suffix: `_${i}`, locationText: loc[`location_${i}`] });
        }

        const hitSummaries = new Set();

        pairs.forEach(({ lat, lng, suffix, locationText }) => {
            const latF = parseFloat(lat);
            const lngF = parseFloat(lng);
            if (isNaN(latF) || isNaN(lngF) || (latF === 0 && lngF === 0)) return;

            const summary = findSummaryLocation(latF, lngF);
            if (summary) {
                hitSummaries.add(summary.id);
                return; // skip — absorbed into the summary marker
            }

            const markerId = `${loc.id}${suffix}`;
            const featuredLocation = findFeaturedLocation(latF, lngF);
            if (featuredLocation) coveredFeaturedSlugs.add(featuredLocation.slug);
            const marker = L.marker([latF, lngF], { icon, recordCount: 1 });
            marker.on('click', () => {
                showInfoPanel(buildPopup(loc, locationText, featuredLocation), loc.featured == 1 || !!featuredLocation);
                populateTable(baseFilteredLocations);
            });
            markers[markerId] = marker;
            newMarkers.push(marker);
        });

        hitSummaries.forEach(sid => {
            summaryBuckets[sid].push(loc);
            locSummaryMap.set(loc.id, sid);
        });
    });

    // Batch-add for performance
    clusterGroup.addLayers(newMarkers);

    const fallbackMarkers = [];

    SUMMARY_LOCATIONS.forEach(s => {
        const bucket = summaryBuckets[s.id];
        if (bucket.length === 0) return;

        if (bucket.length > SUMMARY_THRESHOLD || s.story) {
            // Enough filtered records, or this is a featured location — show the summary marker
            summaryMarkers[s.id] = createSummaryMarker(s, bucket);
            clusterGroup.addLayer(summaryMarkers[s.id]);
            if (s.storyslug) coveredFeaturedSlugs.add(s.storyslug);
        } else {
            // Filtering reduced the count below the threshold — show individual pins
            bucket.forEach(loc => {
                const pinColor = loc.execution == 1 ? PIN_EXECUTION
                               : loc.fatality  == 1 ? PIN_FATALITY
                               : PIN_DEFAULT;
                const icon = createPinIcon(pinColor);

                // Find the location text whose coordinate matches this summary site
                let locationText = null;
                const pairs = [{ lat: loc.latitude, lng: loc.longitude, text: loc.location }];
                for (let i = 2; i <= 10; i++) {
                    pairs.push({ lat: loc[`latitude_${i}`], lng: loc[`longitude_${i}`], text: loc[`location_${i}`] });
                }
                for (const { lat, lng, text } of pairs) {
                    if (Math.abs(parseFloat(lat) - s.lat) < SUMMARY_TOLERANCE &&
                        Math.abs(parseFloat(lng) - s.lng) < SUMMARY_TOLERANCE) {
                        locationText = text;
                        break;
                    }
                }

                const featuredLocation = findFeaturedLocation(s.lat, s.lng);
                if (featuredLocation) coveredFeaturedSlugs.add(featuredLocation.slug);
                const marker = L.marker([s.lat, s.lng], { icon, recordCount: 1 });
                marker.on('click', () => {
                    showInfoPanel(buildPopup(loc, locationText, featuredLocation), loc.featured == 1 || !!featuredLocation);
                    populateTable(baseFilteredLocations);
                });
                markers[`${loc.id}_fb_${s.id}`] = marker;
                fallbackMarkers.push(marker);
            });
        }
    });

    if (fallbackMarkers.length > 0) {
        clusterGroup.addLayers(fallbackMarkers);
    }

    // Ensure every FEATURED_LOCATION is visible even when filtering leaves no records at its
    // coordinate (e.g. when "Stories" filter is active but no individual there has featured=1).
    const storyOnlyMarkers = [];
    FEATURED_LOCATIONS.forEach(f => {
        if (coveredFeaturedSlugs.has(f.slug)) return;
        if (locationFilter && !f.location.toLowerCase().includes(locationFilter)) return;
        const fLat = parseFloat(f.latitude);
        const fLng = parseFloat(f.longitude);
        if (isNaN(fLat) || isNaN(fLng)) return;
        const storyUrl = `${window.featuredStory1916BaseUrl}/${f.slug}`;
        let html = `${STAR_ICON}<h3><a href="${storyUrl}">${f.storyname}</a></h3>`;
        html += `<p><strong>Location:</strong> ${f.location}</p>`;
        if (f.image) html += `<img class="map-popup-image mb-2" src="${f.image}" />`;
        html += `<p><a href="${storyUrl}" class="leaflet-popup-link">Read featured story</a></p>`;
        const icon = createPinIcon(PIN_SUMMARY);
        const marker = L.marker([fLat, fLng], { icon, recordCount: 1 });
        marker.on('click', () => {
            showInfoPanel(html, true);
            populateTable(baseFilteredLocations);
        });
        markers[`featured_${f.slug}`] = marker;
        storyOnlyMarkers.push(marker);
    });
    if (storyOnlyMarkers.length > 0) {
        clusterGroup.addLayers(storyOnlyMarkers);
    }
}

// Returns true if any location text field on a record contains the given string (case-insensitive)
function locationFieldContains(loc, str) {
    const fields = ['location'];
    for (let i = 2; i <= 13; i++) fields.push(`location_${i}`);
    return fields.some(f => (loc[f] || '').toLowerCase().includes(str));
}

// Returns the first location text that matches the search string, or null if none match
function findMatchingLocation(loc, str) {
    const fields = ['location'];
    for (let i = 2; i <= 13; i++) fields.push(`location_${i}`);
    for (const f of fields) {
        if ((loc[f] || '').toLowerCase().includes(str)) return loc[f];
    }
    return null;
}

// Apply all filters and refresh map + table.
// When a summary pin is active, only the table is refined (within those records);
// the map is left unchanged.
function applyFilters() {
    const nameVal = (document.getElementById('filter-1916-name')?.value || '').trim().toLowerCase();
    const locationVal = (document.getElementById('filter-1916-location')?.value || '').trim().toLowerCase();
    const genderVal = (document.getElementById('filter-1916-gender')?.value || '').trim().toLowerCase();
    const organisationVal = (document.getElementById('filter-1916-organisation')?.value || '').trim().toLowerCase();
    const countyVal = (document.getElementById('filter-1916-county')?.value || '').toLowerCase();
    const executionOnly = document.getElementById('filter-1916-execution')?.checked || false;
    const fatalityOnly = document.getElementById('filter-1916-fatality')?.checked || false;
    const featuredOnly = document.getElementById('filter-1916-featured')?.checked || false;

    const matchesFilters = loc => {
        const nameMatch = !nameVal || (loc.name || '').toLowerCase().includes(nameVal);
        const locationMatch = !locationVal || locationFieldContains(loc, locationVal);
        const genderMatch = !genderVal || (loc.gender || '').toLowerCase() === genderVal;
        const organisationMatch = !organisationVal || (loc.organisation || '').toLowerCase() === organisationVal;
        const countyMatch = !countyVal || (loc.county || '').toLowerCase() === countyVal;
        const executionMatch = !executionOnly || loc.execution == 1;
        const fatalityMatch = !fatalityOnly || loc.fatality == 1;
        const featuredMatch = !featuredOnly || loc.featured == 1;
        return nameMatch && locationMatch && genderMatch && organisationMatch && countyMatch && executionMatch && fatalityMatch && featuredMatch;
    };

    if (activeSummaryLocations) {
        // Summary pin active — refine the table within its records, leave the map alone
        const summaryFiltered = activeSummaryLocations.filter(matchesFilters);
        const summaryMatchedLocationsMap = locationVal
            ? new Map(summaryFiltered.map(loc => [loc.id, findMatchingLocation(loc, locationVal)]))
            : null;
        populateTable(summaryFiltered, summaryMatchedLocationsMap);
        return;
    }

    hideInfoPanel();
    const filtered = allLocations.filter(matchesFilters);

    // Build a map of loc.id → matched location text when filtering by location
    const matchedLocationsMap = locationVal
        ? new Map(filtered.map(loc => [loc.id, findMatchingLocation(loc, locationVal)]))
        : null;

    baseFilteredLocations = filtered;
    addMarkers(filtered, locationVal);
    populateTable(filtered, matchedLocationsMap);
}

// Fetch locations from the API and initialise everything
fetch(apiUrl)
    .then(res => res.json())
    .then(data => {
        allLocations = data;
        baseFilteredLocations = data;
        SUMMARY_LOCATIONS = computeDynamicSummaryLocations(data, SUMMARY_THRESHOLD);

        // Promote any summary location that matches a featured location
        SUMMARY_LOCATIONS.forEach(s => {
            const featured = findFeaturedLocation(s.lat, s.lng);
            if (featured) {
                s.story = true;
                s.storyslug = featured.slug;
                s.image = featured.image;
                s.storyname = featured.storyname || null;
            }
        });

        addMarkers(allLocations);
        populateTable(allLocations);
    })
    .catch(err => console.error('1916 locations API error:', err));

function resetCheckboxFilters() {
    ['filter-1916-execution', 'filter-1916-fatality', 'filter-1916-featured'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.checked = false;
    });
}

// Wire up filter inputs
document.addEventListener('DOMContentLoaded', () => {
    resetCheckboxFilters();
    document.getElementById('filter-1916-name')?.addEventListener('input', applyFilters);
    document.getElementById('filter-1916-location')?.addEventListener('input', applyFilters);
    document.getElementById('filter-1916-gender')?.addEventListener('change', applyFilters);
    document.getElementById('filter-1916-organisation')?.addEventListener('change', applyFilters);
    document.getElementById('filter-1916-county')?.addEventListener('change', applyFilters);

    document.getElementById('load-more-1916')?.addEventListener('click', () => {
        const tbody = document.getElementById('locations-1916-tbody');
        if (!tbody) return;
        if (tableVisibleCount >= currentFilteredLocations.length) {
            // Collapse back to first page
            tbody.innerHTML = '';
            const slice = currentFilteredLocations.slice(0, PAGE_SIZE);
            slice.forEach(loc => tbody.appendChild(buildTableRow(loc, currentMatchedLocationsMap?.get(loc.id))));
            tableVisibleCount = slice.length;
            document.getElementById('locations-1916-table')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            const slice = currentFilteredLocations.slice(tableVisibleCount, tableVisibleCount + PAGE_SIZE);
            slice.forEach(loc => tbody.appendChild(buildTableRow(loc, currentMatchedLocationsMap?.get(loc.id))));
            tableVisibleCount += slice.length;
        }
        updateLoadMoreButton();
    });
    const executionCb = document.getElementById('filter-1916-execution');
    const fatalityCb = document.getElementById('filter-1916-fatality');

    executionCb?.addEventListener('change', () => {
        if (executionCb.checked) fatalityCb.checked = false;
        applyFilters();
    });
    fatalityCb?.addEventListener('change', () => {
        if (fatalityCb.checked) executionCb.checked = false;
        applyFilters();
    });

    document.getElementById('filter-1916-featured')?.addEventListener('change', applyFilters);
    document.getElementById('map-close-btn')?.addEventListener('click', () => {
        hideInfoPanel();
        activeSummaryLocations = null;
        applyFilters();
    });

    document.getElementById('map-1916-info-content')?.addEventListener('click', e => {
        const link = e.target.closest('.summary-table-link');
        if (!link) return;
        e.preventDefault();
        document.getElementById('locations-1916-table')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
});

// Recalculate map size once the page is fully laid out.
// Leaflet captures the container dimensions at init time; if the container
// height isn't resolved yet (e.g. CSS loads after the script runs) only a
// partial tile grid is rendered. invalidateSize() forces a recalculation.
window.addEventListener('load', () => map.invalidateSize());

// When navigating back to this page from bfcache, reset checkboxes and re-filter
window.addEventListener('pageshow', e => {
    if (e.persisted) {
        resetCheckboxFilters();
        applyFilters();
    }
});

/* eslint-enable */
